// ReSharper disable once InconsistentNaming
interface DateDiffOptions {
    dateCt11Id?: string,
    timeCtl1Id?: string,
    dateCtl2Id?: string,
    timeCtl2Id?: string,
    rangeMin?: number,
    rangeMax?: number,
}

((($: JQueryStatic) => {
    $.fn.triggerDateDifferenceWarningCheck = function (options:DateDiffOptions) {

        const settings:DateDiffOptions = $.extend({
            dateCt11Id: null,
            timeCtl1Id: null,
            dateCtl2Id: null,
            timeCtl2Id: null,
            rangeMin :0,
            rangeMax :0
        }, options);

        return this.each(function () {

            $(this).change(function () {

                //Trigger the on blur so that time gets updated to the correct mask - i.e. 1 = 1 pm etc
                const ctl = $(this);
                if (ctl.attr("id") === $(settings.timeCtl1Id).attr("id") || ctl.attr("id") === $(settings.timeCtl2Id).attr("id")) {
                    Ahb.Utilities.convertTo24Time(ctl);
                }

                const containers = $("div.date-warning-group");

                // The time components are all valid or null. Check the date parts.
                const date1 = Ahb.Utilities.elemToDate($(settings.dateCt11Id));
                const date2 = Ahb.Utilities.elemToDate($(settings.dateCtl2Id));

                //Reset the warning if any of the fields is empty
                if (date1 == null
                    || $(settings.timeCtl1Id).val() == ""
                    || date2 == null
                    || $(settings.timeCtl2Id).val() == "") {
                    // Remove all previous appended warnings
                    $(containers).find("span.message").remove();
                    $(containers).attr("class", "date-warning-group");
                    return true;
                }

                const hours = Ahb.Utilities.getDifferenceInHours(settings.dateCt11Id, settings.timeCtl1Id, settings.dateCtl2Id, settings.timeCtl2Id);

                containers.each(function () {
                    // Remove all previous appended warnings to reset the state
                    $(this).find("span.message").remove();
                    $(this).attr("class", "date-warning-group");

                    if (hours > settings.rangeMax) {
                        $(this).attr("class", "date-warning-group warn");
                        $(this).append("<span class='message'>More than 78 hrs between Inject and Read</span>");
                    } else if (hours < settings.rangeMin) {
                        $(this).attr("class", "date-warning-group warn");
                        $(this).append("<span class='message'>Less than 66 hrs between Inject and Read</span>");
                    }
                });


                return true;
            });


        });
    };
})(jQuery));



// WEBPACK FOOTER //
// ./ScriptsTS/AhbDateDifferenceWarning.ts